import * as React from 'react';
import Dialog from '@mui/material/Dialog';
import Slide from '@mui/material/Slide';
import { styled } from '@mui/material/styles';

import { ListingDetail } from './index';

const Container = styled(Dialog)({ zIndex: 999 });

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

/**
 * The listing detail as a modal.
 *
 * This used to be the ONLY way to see a listing, which is why no listing had a
 * URL. Browsing now routes to /listing/:id instead.
 *
 * The modal survives for one case: previewing an option from inside a flow the
 * traveller must not be routed out of — currently the itinerary builder's
 * `HorizontalSelectableCards`, where navigating away would discard the
 * in-progress selection. Use the route everywhere else.
 */
export function ListingDetailDialog({ open, handleClose, listing }) {
  return (
    <Container
      fullScreen
      open={Boolean(open)}
      onClose={handleClose}
      TransitionComponent={Transition}
      aria-label="Listing details"
    >
      <ListingDetail listing={listing} onBack={handleClose} inDialog />
    </Container>
  );
}

export default ListingDetailDialog;
